import { render } from "./ProgramApplicants.vue?vue&type=template&id=3b6855be&scoped=true"
import script from "./ProgramApplicants.vue?vue&type=script&lang=ts"
export * from "./ProgramApplicants.vue?vue&type=script&lang=ts"

import "./ProgramApplicants.vue?vue&type=style&index=0&id=3b6855be&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-3b6855be"
/* custom blocks */
import block0 from "./ProgramApplicants.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script